import type { AnalysisStatistics } from './schema';

export async function recordStatistics(event:AnalysisStatistics):Promise<{status:number;used?:number}> {
 try {
  const response=await fetch('/api/analytics',{
   method:'POST',credentials:'include',headers:{'content-type':'application/json'},body:JSON.stringify(event)
  });
  if(!response.ok)return {status:response.status};
  const data=await response.json() as {analysesThisMonth?:number};
  return {status:response.status,used:data.analysesThisMonth};
 } catch {return {status:0};}
}
